
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/block-crm/26-hsp",
      function () {
        return require("private-next-pages/block-crm/26-hsp.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/block-crm/26-hsp"])
      });
    }
  